import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import {
  CustomTextField,
  CustomTextArea,
  CustomCheckbox,
  HorizontalForm,
} from '../../../common';
import {
  capitalizeWords,
  generateEmailSubject,
  generateEmailMessage,
  generateDebtEmailSubject,
  generateDebtEmailMessage,
} from '../utils/couponsMailsUtils';

const EmailComposeView = ({
  open,
  emailData,
  plans,
  onNoteChange,
  resetNoteFlag,
  isDebt,
  cuotaPura,
}) => {
  const [to, setTo] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [note, setNote] = useState('');
  const [isNoteEnabled, setIsNoteEnabled] = useState(false);

  const formattedName = emailData
    ? capitalizeWords(`${emailData.first_name} ${emailData.last_name}`)
    : '';

  useEffect(() => {
    if (onNoteChange) {
      onNoteChange(note);
    }
  }, [note, onNoteChange]);

  useEffect(() => {
    if (resetNoteFlag) {
      setNote('');
      setIsNoteEnabled(false);
    }
  }, [resetNoteFlag]);

  useEffect(() => {
    if (open && emailData) {
      const planName =
        plans.find((plan) => plan.uuid === emailData.contract?.uuid_plan)?.name || '';
      const defaultSubject = isDebt
        ? generateDebtEmailSubject(planName, emailData.contract_number)
        : generateEmailSubject(planName, emailData.contract_number);
      const defaultMessage = isDebt
        ? generateDebtEmailMessage(formattedName, emailData, planName, cuotaPura)
        : generateEmailMessage(formattedName, emailData, planName);

      const subscriberEmail = emailData.email || emailData.subscriber?.email;
      const normalizedEmail = subscriberEmail && subscriberEmail.trim() !== '' ? subscriberEmail : 'no-user-email@gmail.com';
      setTo(normalizedEmail);
      setSubject(defaultSubject);
      setMessage(defaultMessage);
    }
  }, [open, emailData, plans, formattedName, isDebt, cuotaPura]);

  const handleNoteToggle = (checked) => {
    setIsNoteEnabled(checked);
    if (!checked) {
      setNote('');
    }
  };

  return (
    <>
      <HorizontalForm withBorder={false} sx={{ gap: 2, p: 0 }}>
        <CustomTextField
          label="Para:"
          value={to}
          onChange={(e) => setTo(e.target.value)}
          disabled
          sx={{ mb: 2 }}
        />

        <CustomTextField
          label="De:"
          value="administracion@constructoracolonial.com.ar"
          disabled
          sx={{ mb: 2 }}
        />

        <CustomTextField
          label="Asunto:"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          disabled
          sx={{ mb: 2 }}
        />
      </HorizontalForm>
      <CustomTextArea
        label="Mensaje:"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        disabled
        minRows={10}
        sx={{ mb: 2 }}
      />

      <HorizontalForm withBorder={false} sx={{ gap: 2, p: 0}}>
        <Box sx={{ flex: 1 }}>
          <CustomTextArea
            label="Nota:"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            disabled={!isNoteEnabled}
            minRows={2}
            placeholder="Escriba su nota aquí..."
          />
        </Box>
        <Box sx={{ mt: 2 }}>
          <CustomCheckbox
            checked={isNoteEnabled}
            onChange={(e) => handleNoteToggle(e.target.checked)}
            label=""
          />
        </Box>
      </HorizontalForm>
    </>
  );
};

export default EmailComposeView;
